import shopsDev from "@/configs/shops";
import shopsStage from "@/configs/shops-stage";
import shopsProd from "@/configs/shops-production";

const getShopEnvConfig = () => {
  if (
    process.env.VUE_APP_PROD == "localhost" ||
    process.env.VUE_APP_PROD == "development" ||
    process.env.VUE_APP_PROD == "dev"
  ) {
    return shopsDev;
  } else if (process.env.VUE_APP_PROD == "stage") {
    return shopsStage;
  } else if (process.env.VUE_APP_PROD == "production" || process.env.VUE_APP_PROD == "prod") {
    return shopsProd;
  }

  if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1") {
    return shopsDev;
  }

  return shopsProd || {};
};

const getShopNameFromUrl = () => {
  const shops = getShopEnvConfig() || {};
  if (
    process.env.VUE_APP_PROD == "localhost" ||
    process.env.VUE_APP_PROD == "development" ||
    process.env.VUE_APP_PROD == "dev" ||
    window.location.hostname === "localhost" ||
    window.location.hostname === "127.0.0.1"
  ) {
    return Object.keys(shops)[0];
  } else {
    return window.location.host;
  }
};

const getShopPagesTemplates = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop]["templates"]) {
    return shops[shop]["templates"];
  }
  return null;
};

const getShopBannerTemplates = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop]["banner_templates"]) {
    return shops[shop]["banner_templates"];
  }
  return null;
};

const getDefaultLanguage = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop]["defaultLanguage"]) {
    return shops[shop]["defaultLanguage"];
  }
  return "sk";
};

const isShopMultilang = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop]["languages"] && shops[shop]["languages"].length > 1) {
    return true;
  }
  return false;
};

const getShopLanguages = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop]) {
    if (shops[shop]["languages"] && shops[shop]["languages"].length) {
      return shops[shop]["languages"];
    } else {
      return ["sk"];
    }
  }
  return false;
};

const getShopCustomActions = (resource = null) => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop]) {
    if (shops[shop]["custom_actions"]) {
      if (resource) {
        return shops[shop]["custom_actions"][resource];
      }
      return shops[shop]["custom_actions"];
    }
  }
  return [];
};

const getShopPathOverrides = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop]) {
    if (shops[shop]["path_overrides"]) {
      return shops[shop]["path_overrides"];
    }
  }
  return null;
};

const getRootName = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop]["rootName"]) {
    return shops[shop]["rootName"];
  }
  return null;
};

const getAuthorFilterRoleId = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop].roleIdForAuthorUsers) {
    return shops[shop].roleIdForAuthorUsers;
  }
};

const hasUnitPriceCoefficientEnabled = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop].priceUnitFieldEnabled) {
    return shops[shop].priceUnitFieldEnabled;
  }
  return false;
};

const categorySlugOnProduct = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop].storeCategorySlugOnProduct) {
    return shops[shop].storeCategorySlugOnProduct;
  }
  return false;
};

const showConfigurationDescriptionInOrder = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop].showConfigurationDescriptionInOrder) {
    return shops[shop].showConfigurationDescriptionInOrder;
  }
  return false;
};

const customImportVarianstUrl = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop].customImportVarianstUrl) {
    return shops[shop].customImportVarianstUrl;
  }
  return false;
};

const defaultOrdersOrdering = () => {
  const shops = getShopEnvConfig() || {};
  const shop = getShopNameFromUrl();
  if (shop && shops[shop] && shops[shop].defaultOrdersOrdering) {
    return shops[shop].defaultOrdersOrdering;
  }
  return false;
};

export default {
  getShopEnvConfig,
  getShopNameFromUrl,
  getShopPagesTemplates,
  getShopBannerTemplates,
  getDefaultLanguage,
  isShopMultilang,
  getShopLanguages,
  getShopCustomActions,
  getShopPathOverrides,
  getRootName,
  getAuthorFilterRoleId,
  hasUnitPriceCoefficientEnabled,
  categorySlugOnProduct,
  showConfigurationDescriptionInOrder,
  customImportVarianstUrl,
  defaultOrdersOrdering,
};
